import { render, staticRenderFns } from "./DataviewList.vue?vue&type=template&id=987f125c"
import script from "./DataviewList.vue?vue&type=script&lang=js"
export * from "./DataviewList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports